import { LoginInputType } from './types';
import { emailRegex } from '../utils';
import { isCorrectPhoneNumber } from '../PhoneInput/utils';
const normalizeEmailDomain = (domain) => domain.trim().replace(/^@+/, '').toLowerCase();
export const isEmailDomainBlockedForRegistration = (email, blockedDomains) => {
    if (!(blockedDomains === null || blockedDomains === void 0 ? void 0 : blockedDomains.length)) {
        return false;
    }
    const emailDomain = email.slice(email.lastIndexOf('@') + 1);
    const normalizedEmailDomain = normalizeEmailDomain(emailDomain);
    return blockedDomains.some(blockedDomain => normalizeEmailDomain(blockedDomain) === normalizedEmailDomain);
};
export const detectInputType = (value) => {
    if (emailRegex.test(value)) {
        return LoginInputType.Email;
    }
    else if (isCorrectPhoneNumber(value)) {
        return LoginInputType.Phone;
    }
    else {
        return LoginInputType.Text;
    }
};
export const getLoginTypeValue = (loginTypes, loginType) => {
    var _a;
    return (_a = loginTypes.find(({ type }) => type === loginType)) === null || _a === void 0 ? void 0 : _a.value;
};
